import Head from 'next/head'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

// Constants
import { envConfigs } from '@/constants/config'
import { DEFAULT_LOCALE } from '@/constants/defaultLocale'

type Props = {
  /** 不含「| 幫助中心」 */
  title?: string
  description?: string
  /** 不含語系前綴與 query，例如 /help/articles/12 */
  canonicalPath: string
  /** 搜尋結果頁不給搜尋引擎收錄 */
  noIndex?: boolean
  /** 條款頁：標題不加「| 幫助中心」 */
  standalone?: boolean
}

const HelpHead = ({ title, description, canonicalPath, noIndex, standalone }: Props) => {
  const { t } = useTranslation()
  const router = useRouter()
  const currentLocale = router.locale === 'default' ? DEFAULT_LOCALE : router.locale
  const siteTitle = t('Footer_Help_Center')
  const fullTitle = title ? (standalone ? title : `${title} | ${siteTitle}`) : siteTitle
  const url = `${envConfigs.domainUrl}/${currentLocale}${canonicalPath}`

  return (
    <Head>
      <title>{fullTitle}</title>
      <link rel='canonical' href={url} />
      <meta name='title' key='meta-title' content={fullTitle} />
      {description && <meta name='description' key='meta-description' content={description} />}
      <meta property='og:title' key='og-title' content={fullTitle} />
      {description && <meta property='og:description' key='description' content={description} />}
      <meta property='og:type' key='type' content='article' />
      <meta property='og:url' key='og-url' content={url} />
      {noIndex && <meta name='robots' content='noindex, follow' />}
    </Head>
  )
}

export default HelpHead
